export default [
  {
    link: 'https://местопамяти.рф/',
    src: '/imgs/banners/mp-ad.jpg',
    text: '',
    outerLink: true,
  },
  {
    link: 'https://rvio.histrf.ru/activities/news/mezhdunarodnyj-konkurs-na-sozdanie-hudozhestvennogo-scenariya-o-vklade-narodov-sssr-v-pobedu-2025',
    src: '/imgs/banners/cncrs.jpg',
    text: '',
    outerLink: true,
  },
];
